module.exports = __webpack_public_path__ + "img/date-time.76a34e6a.svg";